import { createSelector } from 'reselect';
import CarrierCarditResditBestPracticeElementsColumns from '../../containers/CarrierCarditResditBestPracticeElementsColumns';

// eslint-disable-next-line max-len
export const getGeneratedOnDateTime = state => state.reporting.CARDIT_RESDIT_BEST_PRACTICE_ELEMENTS_804.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARDIT_RESDIT_BEST_PRACTICE_ELEMENTS_804.isLoading;

export const getData = state => state.reporting.CARDIT_RESDIT_BEST_PRACTICE_ELEMENTS_804.data;

export const getColumns = createSelector(
  getData,
  state => state.userData.userType,
  CarrierCarditResditBestPracticeElementsColumns,
);
